import React from 'react';
import Banner from '../Components/Banner';
import { useLanguage } from '../context/LanguageContext';
import ColorBtn from '../Components/ColorBtn';

function Portfolio() {
  const { t } = useLanguage();
  return (
    <div className="page-wrap">
      <Banner pageName={t.pages.portfolio} pageLink="/portfolio" subtitle={t.portfolio.subtitle} />
      <section className="section">
        <div className="container">
          <div className="section-title center">
            <div className="eyebrow">Project models</div>
            <h2>{t.portfolio.title}</h2>
            <p>{t.portfolio.intro}</p>
          </div>
          <div className="grid-4">
            {t.portfolio.items.map((item) => (
              <article className="info-card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </article>
            ))}
          </div>
          <div style={{ marginTop: 28, display: 'flex', justifyContent: 'center' }}>
            <ColorBtn colorBtnLink="/contact" btnName={t.common.contactNow} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Portfolio;
